<template>
  <Accordion
    :error="$v.nfse.generalInformation.$error"
    id="generalInformation"
    title="INFORMAÇÕES GERAIS"
  >
    <b-row class="row-padding">
      <b-col md="4">
        <SelectNfseNatureOfOperation
          :disabled="disabled"
          :error="$v.nfse.generalInformation.natureOfOperation.$error"
          v-model="nfse.generalInformation.natureOfOperation"
        />
      </b-col>
      <b-col md="6" lg="3">
        <SelectUser
          :disabled="disabled"
          :error="$v.nfse.generalInformation.user.$error"
          v-model="nfse.generalInformation.user"
        />
      </b-col>
      <b-col lg="2">
        <Input
          label="ART"
          labelBold
          :disabled="disabled"
          v-model="nfse.generalInformation.art"
          :maxlength="20"
        />
      </b-col>
      <b-col lg="3">
        <Input
          label="Nº interno"
          labelBold
          disabled
          :value="nfse.generalInformation.serie.internalNumber"
        />
      </b-col>
    </b-row>
    <b-row class="row-padding pb-0">
      <b-col md="6" lg="3" class="text-center">
        <b-col><Label>Incentivador Cultural</Label></b-col>
        <b-row>
          <b-col
            ><CheckboxSwitch
              id="culturalEncouraging"
              :tooltipPosition="'bottom'"
              :disabled="disabled"
              v-model="nfse.generalInformation.culturalEncouraging"
          /></b-col>
        </b-row>
      </b-col>
      <b-col md="6" lg="3">
        <SelectIncidence
          :clearable="false"
          :default="true"
          :disabled="disabled"
          v-model="nfse.generalInformation.incidence"
        />
      </b-col>
      <b-col lg="3">
        <Input
          label="Cód. da obra"
          labelBold
          :disabled="disabled"
          v-model="nfse.generalInformation.workCode"
          :maxlength="20"
        />
      </b-col>
      <b-col lg="3">
        <Input
          label="RPS"
          labelBold
          :disabled="disabled"
          :mask="['###############']"
          v-model="nfse.generalInformation.serie.rps"
        />
      </b-col>
    </b-row>
  </Accordion>
</template>

<script>
import {
  Accordion,
  SelectNfseNatureOfOperation,
  SelectIncidence,
  Label,
  CheckboxSwitch,
  SelectUser,
} from '@/components';
import { mapActions, mapState } from 'vuex';
import { Input } from '@/components/Form';
import { required } from '@/reusable/validations';
import NumbersMixin from '@/modules/Application/mixins/NumbersMixin';

export default {
  name: 'GeneralInformation',
  mixins: [NumbersMixin],
  components: {
    Accordion,
    Input,
    CheckboxSwitch,
    Label,
    SelectNfseNatureOfOperation,
    SelectIncidence,
    SelectUser,
  },
  validations: {
    nfse: {
      generalInformation: {
        natureOfOperation: { required },
        user: { required },
      },
    },
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    if (!this.nfse.id) {
      await this.setLastNatureOfOperation();
      await this.getCurrentUser();
      this.nfse.generalInformation.user = this.currentUser;
    }
  },
  computed: {
    ...mapState('nfse', ['nfse']),
    ...mapState('client', ['currentUser']),
  },
  methods: {
    ...mapActions('nfse', ['setLastNatureOfOperation']),
    ...mapActions('application', ['setLoading']),
    ...mapActions('client', ['getCurrentUser']),
  },
};
</script>
